'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { useRouter } from '@flipster/i18n/routing';
import { Dialog } from '@flipster/react/design-system/dialog';
import CautionCircleIcon from '@flipster/react/icon/generated/CautionCircleIcon';
import { token } from '@flipster/styled-system/tokens';

import { countryRestrictionBunja } from './state';

export const CountryRestrictionDialog = () => {
  const router = useRouter();
  const { isTradableAtom, isTradFiInstrumentAtom } = useBunja(countryRestrictionBunja);
  const isTradable = useAtomValue(isTradableAtom);
  const isTradFi = useAtomValue(isTradFiInstrumentAtom);

  if (isTradable) return null;

  return (
    <Dialog.Root isOpen>
      <Dialog.Title
        leftAddon={<CautionCircleIcon color={token('colors.content.state.warning')} />}
        label={
          isTradFi ? (
            <FormattedMessage id='Trade.r260708.Tradfi_trading_isnt_available_in_your_region' />
          ) : (
            <FormattedMessage id='Trade.r260205.Region_block_title' />
          )
        }
      />
      <Dialog.Content>
        {isTradFi ? (
          <FormattedMessage id='Trade.r260708.Tradfi_trading_isnt_available_in_your_region_body' />
        ) : (
          <FormattedMessage id='Trade.r260205.Region_block_body' />
        )}
      </Dialog.Content>
      <Dialog.Footer>
        <Dialog.Button
          label={<FormattedMessage id='Common.r250401.Confirm' />}
          onClick={() => router.push('/market')}
        />
      </Dialog.Footer>
    </Dialog.Root>
  );
};
